import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import tr from "date-fns/locale/tr";
import $ from "jquery";
import {
  getMyDemands,
  selectWorkflow,
} from "../../../state/ducks/workflow/index";
import RenderDemandDetail from "./RenderDemandDetail";
import StaticModal from "../shared/StaticModal";
import EminevimLoading from "../shared/EminevimLoading";
import AppCustomSelect from "../shared/AppCustomSelect";

const formatDemandDate = (value) => {
  if (!value) return "-";
  return new Date(value).toLocaleString("tr-TR");
};

class MyDemands extends Component {
  state = {
    startDate: null,
    endDate: null,
    isDateFilterActive: false,
    pageSize: 10,
    currentPage: 1,
    sortField: "acilisTarihi",
    sortDirection: "desc",
    isLoading: true,
    shouldAnimateCard: false,
  };

  componentDidMount() {
    this.props.getMyDemands();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.workflow?.list !== this.props.workflow?.list) {
      if (this.state.isLoading) {
        this.setState({ isLoading: false, shouldAnimateCard: true });
        window.setTimeout(() => this.setState({ shouldAnimateCard: false }), 900);
      }
    }
  }

  getDemandsForDisplay = () => {
    const demands = this.props.workflow?.list;
    if (!demands) return [];

    let result = [...demands];
    const { startDate, endDate, isDateFilterActive } = this.state;

    if (!isDateFilterActive) {
      return result;
    }

    if (startDate) {
      result = result.filter((item) => new Date(item.acilisTarihi) >= startDate);
    }

    if (endDate) {
      result = result.filter((item) => {
        const createDate = new Date(item.acilisTarihi);
        return (
          new Date(createDate.getFullYear(), createDate.getMonth(), createDate.getDate()) <=
          endDate
        );
      });
    }

    return result;
  };

  getSortedDemands = () => {
    const { sortField, sortDirection } = this.state;
    const demands = [...this.getDemandsForDisplay()];

    demands.sort((leftItem, rightItem) => {
      const left = leftItem?.[sortField];
      const right = rightItem?.[sortField];

      if (sortField === "acilisTarihi") {
        const leftTime = new Date(left).getTime() || 0;
        const rightTime = new Date(right).getTime() || 0;
        return sortDirection === "asc" ? leftTime - rightTime : rightTime - leftTime;
      }

      if (sortField === "talepNo") {
        const leftNum = Number(left) || 0;
        const rightNum = Number(right) || 0;
        return sortDirection === "asc" ? leftNum - rightNum : rightNum - leftNum;
      }

      const leftText = (left || "").toString().toLowerCase();
      const rightText = (right || "").toString().toLowerCase();

      if (leftText < rightText) return sortDirection === "asc" ? -1 : 1;
      if (leftText > rightText) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });

    return demands;
  };

  getPaginatedDemands = () => {
    const demands = this.getSortedDemands();
    const { currentPage, pageSize } = this.state;
    const startIndex = (currentPage - 1) * pageSize;

    return demands.slice(startIndex, startIndex + pageSize);
  };

  getTotalPages = () => {
    const totalItems = this.getSortedDemands().length;
    return Math.max(1, Math.ceil(totalItems / this.state.pageSize));
  };

  filterList = () => {
    const demands = this.props.workflow?.list;

    if (demands === undefined) {
      $("#hata_mesaji").modal("show");
      return;
    }

    this.setState({ isDateFilterActive: true, currentPage: 1 });
  };

  handleChange = (date) => {
    this.setState({ startDate: date });
  };

  handleChangeEnd = (date) => {
    this.setState({ endDate: date });
  };

  handlePageSizeChange = (event) => {
    this.setState({
      pageSize: Number(event.target.value),
      currentPage: 1,
    });
  };

  handleSort = (field) => {
    this.setState((prevState) => ({
      sortField: field,
      sortDirection:
        prevState.sortField === field && prevState.sortDirection === "asc" ? "desc" : "asc",
      currentPage: 1,
    }));
  };

  goToPage = (page) => {
    const totalPages = this.getTotalPages();
    const nextPage = Math.min(Math.max(page, 1), totalPages);
    this.setState({ currentPage: nextPage });
  };

  renderSortIcon = (field) => {
    const { sortField, sortDirection } = this.state;

    if (sortField !== field) {
      return <i className="t-icon-unfold_more t-myDemands-sortIcon" aria-hidden="true" />;
    }

    return (
      <i
        className={`t-icon-keyboard_arrow_${sortDirection === "asc" ? "up" : "down"} t-myDemands-sortIcon t-myDemands-sortIcon--active`}
        aria-hidden="true"
      />
    );
  };

  renderDemandsLoading = () => (
    <EminevimLoading subtext="Talepleriniz hazırlanıyor, lütfen bekleyiniz." />
  );

  renderDateFilter = () => (
    <div className="t-myDemands-dateFilter">
      <span className="t-resetPassword-label">Açılma tarihi aralığı</span>
      <div className="t-myDemands-dateFields">
        <div className="t-myDemands-dateField m-takvim">
          <div className="input-group">
            <div className="input-group-prepend" onClick={() => $(".t-myDemands-dateStart").focus()}>
              <span className="input-group-text m-takvimiconhizalama">
                <i className="t-icon-calendar1" aria-hidden="true" />
              </span>
            </div>
            <DatePicker
              className="t-myDemands-dateStart m-datepicker"
              selected={this.state.startDate}
              dateFormat="dd.MM.yyyy"
              popperClassName="form"
              calendarClassName="rasta-stripes"
              locale={tr}
              placeholderText="Başlangıç tarihi"
              onChange={this.handleChange}
            />
          </div>
        </div>

        <div className="t-myDemands-dateField m-takvim">
          <div className="input-group">
            <div className="input-group-prepend" onClick={() => $(".t-myDemands-dateEnd").focus()}>
              <span className="input-group-text m-takvimiconhizalama">
                <i className="t-icon-calendar1" aria-hidden="true" />
              </span>
            </div>
            <DatePicker
              className="t-myDemands-dateEnd m-datepicker"
              selected={this.state.endDate}
              dateFormat="dd.MM.yyyy"
              locale={tr}
              placeholderText="Bitiş tarihi"
              onChange={this.handleChangeEnd}
            />
          </div>
        </div>

        <button
          type="button"
          className="t-memberInfo-btn t-memberInfo-btn--primary t-myDemands-filterButton"
          onClick={this.filterList}
        >
          <span>Getir</span>
          <i className="t-icon-arrow-right2" aria-hidden="true" />
        </button>
      </div>
    </div>
  );

  renderToolbar = () => (
    <div className="t-myDemands-toolbar">
      {this.renderDateFilter()}

      <div className="t-myDemands-pageSize">
        <label htmlFor="demandPageSize" className="t-myDemands-pageSizeLabel">
          Sayfa
        </label>
        <div className="t-myDemands-pageSizeSelect">
          <AppCustomSelect
            id="demandPageSize"
            value={this.state.pageSize}
            options={[
              { value: "10", label: "10" },
              { value: "20", label: "20" },
              { value: "50", label: "50" },
              { value: "100", label: "100" },
            ]}
            onChange={(nextValue) => this.handlePageSizeChange({ target: { value: nextValue } })}
          />
        </div>
      </div>
    </div>
  );

  renderDesktopTable = (demands) => (
    <div className="t-myDemands-tableWrap">
      <table className="t-myDemands-table">
        <thead>
          <tr>
            <th scope="col">
              <button type="button" className="t-myDemands-sortButton" onClick={() => this.handleSort("talepNo")}>
                Talep No
                {this.renderSortIcon("talepNo")}
              </button>
            </th>
            <th scope="col">
              <button type="button" className="t-myDemands-sortButton" onClick={() => this.handleSort("konu")}>
                Konu
                {this.renderSortIcon("konu")}
              </button>
            </th>
            <th scope="col">
              <button
                type="button"
                className="t-myDemands-sortButton"
                onClick={() => this.handleSort("acilisTarihi")}
              >
                Açılma Tarihi
                {this.renderSortIcon("acilisTarihi")}
              </button>
            </th>
            <th scope="col">
              <button type="button" className="t-myDemands-sortButton" onClick={() => this.handleSort("durumu")}>
                Durumu
                {this.renderSortIcon("durumu")}
              </button>
            </th>
            <th scope="col" className="t-myDemands-detailColumn">
              Detay
            </th>
          </tr>
        </thead>
        <tbody>
          {demands.map((item) => (
            <tr key={item.talepNo}>
              <td data-label="Talep No">{item.talepNo || "-"}</td>
              <td data-label="Konu">{item.konu || "-"}</td>
              <td data-label="Açılma Tarihi">{formatDemandDate(item.acilisTarihi)}</td>
              <td data-label="Durumu">{item.durumu || "-"}</td>
              <td data-label="Detay" className="t-myDemands-detailCell">
                <RenderDemandDetail data={item} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  renderMobileCards = (demands) => (
    <div className="t-myDemands-mobileList">
      {demands.map((item) => (
        <article className="t-myDemands-mobileCard" key={item.talepNo}>
          <div className="t-myDemands-mobileField">
            <span className="t-myDemands-mobileLabel">Talep No</span>
            <span className="t-myDemands-mobileValue">{item.talepNo || "-"}</span>
          </div>
          <div className="t-myDemands-mobileField">
            <span className="t-myDemands-mobileLabel">Konu</span>
            <span className="t-myDemands-mobileValue">{item.konu || "-"}</span>
          </div>
          <div className="t-myDemands-mobileField">
            <span className="t-myDemands-mobileLabel">Açılma Tarihi</span>
            <span className="t-myDemands-mobileValue">{formatDemandDate(item.acilisTarihi)}</span>
          </div>
          <div className="t-myDemands-mobileField">
            <span className="t-myDemands-mobileLabel">Durumu</span>
            <span className="t-myDemands-mobileValue">{item.durumu || "-"}</span>
          </div>
          <div className="t-myDemands-mobileActions">
            <RenderDemandDetail data={item} />
          </div>
        </article>
      ))}
    </div>
  );

  renderPagination = (totalItems) => {
    const { currentPage, pageSize } = this.state;
    const totalPages = this.getTotalPages();
    const startItem = totalItems === 0 ? 0 : (currentPage - 1) * pageSize + 1;
    const endItem = Math.min(currentPage * pageSize, totalItems);

    return (
      <div className="t-myDemands-pagination">
        <span className="t-myDemands-paginationInfo">
          {startItem} ile {endItem} / {totalItems}
        </span>

        <div className="t-myDemands-paginationActions">
          <button
            type="button"
            className="t-myDemands-pageButton"
            onClick={() => this.goToPage(1)}
            disabled={currentPage === 1}
            aria-label="İlk sayfa"
          >
            <i className="t-icon-first" aria-hidden="true" />
          </button>
          <button
            type="button"
            className="t-myDemands-pageButton"
            onClick={() => this.goToPage(currentPage - 1)}
            disabled={currentPage === 1}
            aria-label="Önceki sayfa"
          >
            <i className="t-icon-arrow-left2" aria-hidden="true" />
          </button>
          <span className="t-myDemands-pageIndicator">
            Sayfa {currentPage} / {totalPages}
          </span>
          <button
            type="button"
            className="t-myDemands-pageButton"
            onClick={() => this.goToPage(currentPage + 1)}
            disabled={currentPage === totalPages}
            aria-label="Sonraki sayfa"
          >
            <i className="t-icon-arrow-right2" aria-hidden="true" />
          </button>
          <button
            type="button"
            className="t-myDemands-pageButton"
            onClick={() => this.goToPage(totalPages)}
            disabled={currentPage === totalPages}
            aria-label="Son sayfa"
          >
            <i className="t-icon-last" aria-hidden="true" />
          </button>
        </div>
      </div>
    );
  };

  render() {
    const { shouldAnimateCard, isLoading } = this.state;
    const sortedDemands = this.getSortedDemands();
    const paginatedDemands = this.getPaginatedDemands();
    const totalDemands = (this.props.workflow?.list || []).length;

    return (
      <div style={{ background: "#ffffff" }}>
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            <div className="t-memberInfo-pageHeader">
              <h1 className="t-memberInfo-pageTitle">Taleplerim</h1>
              <p className="t-memberInfo-pageSubtitle">
                Taleplerinizi tarih aralığına göre filtreleyin, durumlarını takip edin ve detaylarını görüntüleyin.
              </p>
            </div>

            {isLoading ? (
              this.renderDemandsLoading()
            ) : (
              <article
                className={`t-memberInfo-card t-memberDetail-header--green${
                  shouldAnimateCard ? " t-memberInfo-card--enter" : ""
                }`}
              >
                <div className="t-memberInfo-cardHeader">
                  <div className="t-memberDetail-headerIcon t-memberInfo-cardIcon">
                    <i className="t-icon-search1" aria-hidden="true" />
                  </div>

                  <div className="t-memberInfo-cardHeaderContent">
                    <h2 className="t-memberInfo-cardTitle">Talep Takibi</h2>
                    <div className="t-memberInfo-cardBadges">
                      <span className="t-memberDetail-headerBadge">
                        Toplam: {totalDemands}
                      </span>
                    </div>
                  </div>

                  <div className="t-memberInfo-cardActions">
                    <Link
                      to="/Home/SubmitDemand"
                      className="t-memberInfo-btn t-memberInfo-btn--primary"
                    >
                      <span>Yeni Talep</span>
                      <i className="t-icon-arrow-right2" aria-hidden="true" />
                    </Link>
                  </div>
                </div>

                {this.renderToolbar()}

                {sortedDemands.length > 0 ? (
                  <>
                    <div className="t-myDemands-desktopOnly">
                      {this.renderDesktopTable(paginatedDemands)}
                    </div>
                    <div className="t-myDemands-mobileOnly">
                      {this.renderMobileCards(paginatedDemands)}
                    </div>

                    {this.renderPagination(sortedDemands.length)}

                    <div className="t-myDemands-summary">
                      Gösterilen: <strong>{sortedDemands.length}</strong>
                      {this.state.isDateFilterActive ? ` / Toplam: ${totalDemands}` : ""}
                    </div>
                  </>
                ) : (
                  <div className="t-memberInfo-emptyFilter">
                    {this.state.isDateFilterActive
                      ? "Seçilen tarih aralığında talep bulunamadı."
                      : "Görüntülenecek talep bulunmuyor."}
                  </div>
                )}
              </article>
            )}
          </div>
        </div>

        <StaticModal />
        <div className="row" style={{ height: 30 }} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  workflow: selectWorkflow(state),
});

const mapDispatchToProps = (dispatch) => ({
  getMyDemands: () => dispatch(getMyDemands()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyDemands);
